module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ba927aa23603e282704613941acd7d08.png";